export class Step2 {

    public getobjet = 'form.mapa_at.getobjet';
    public getvaleurtotaleestimee = 'form.mapa_at.getvaleurtotaleestimee';
    public getdevise = 'form.mapa_at.getdevise';
    public getdateattribution = 'form.mapa_at.getdateattribution';
    public getspan2 = 'form.mapa_at.getspan2';
    public getinfructueux = 'form.mapa_at.getinfructueux';
    public getsanssuite = 'form.mapa_at.getsanssuite';
    public getattribueunique = 'form.mapa_at.getattribueunique';
    public getattribueparlots = 'form.mapa_at.getattribueparlots';
    public getspan3 = 'form.mapa_at.getspan3';
    public getspan4 = 'form.mapa_at.getspan4';
    public getmotsclef = 'form.mapa_at.getmotsclef';
    public getmotclef = 'form.mapa_at.getmotclef';
    public getaddmotclef = 'form.mapa_at.getaddmotclef';
    public getdeletemotclef = 'form.mapa_at.getdeletemotclef';  
}
